var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-2",attrs:{"color":"primary","dark":"","depressed":"","height":"40"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.$t("add_warehouse"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }